import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTheme } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import React, { memo } from 'react';
import { FormattedMessage } from 'react-intl';

import { ensureCurrentUser } from '../util/data';
import useAppSelector from '../util/hooks/useAppSelector';

// Due to the layout structure, do not render the banner on the following pages
const disabledPages = ['SearchPage'];

const LimitedAccessBannerComponent = ({
  isAuthenticated,
  onLogout,
  authScopes = [],
  currentPage = '',
}) => {
  const theme = useTheme();
  const currentUser = useAppSelector((state) => state.user.currentUser);
  const user = ensureCurrentUser(currentUser);

  const showBanner =
    user.id &&
    isAuthenticated &&
    authScopes &&
    authScopes.length === 1 &&
    authScopes[0] === 'user:limited' &&
    !disabledPages.includes(currentPage);

  const { firstName, lastName } = user.attributes.profile;

  return showBanner ? (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.error.main,
        padding: '10px 20px 9px',
      }}
    >
      <Typography color={theme.palette.common.white} variant="body1">
        <FormattedMessage id="LimitedAccessBanner.message" values={{ firstName, lastName }} />
      </Typography>
      <Button color="secondary" onClick={onLogout} variant="contained">
        <FormattedMessage id="LimitedAccessBanner.logout" />
      </Button>
    </Stack>
  ) : null;
};

LimitedAccessBannerComponent.displayName = 'LimitedAccessBanner';

const LimitedAccessBanner = memo(LimitedAccessBannerComponent);

export default LimitedAccessBanner;
